import React from "react";
import autobahn from "autobahn-browser";

const url = "ws://172.33.1.8:8080/ws";
const realm = "dappnode_admin";

const WampConnect = ({ onConnect }) => {

    React.useEffect(() => {
      
        const connection = new autobahn.Connection({
            url,
            realm
        });

        connection.onopen = session => {
            console.log("CONNECTED to \nurl: " + url + " \nrealm: " + realm);
            onConnect(session);
        };

        // connection closed, lost or unable to connect
        connection.onclose = (reason, details) => {
            console.error("CONNECTION_CLOSE", { reason, details });
        };
        connection.open();
    });
    return null;

}

export default WampConnect;
